import React from 'react'
import { useAtomValue } from 'infrastructure/state/jotai.wrapper'
import { currentFlowTag, presentationFolderResetAtom } from './atoms'
import { BorderedContainer } from '../utility/Containers'
import { CurrentUser } from './CurrentUser'
import { useSetStatus } from './hooks'
import { FlowIdView } from '../contentService/JobView'
import { GDriveFileResponse } from '../contentService/types'

export function CurrentJobData() {
  const jobFlowTag = useAtomValue(currentFlowTag)
  const setStatus = useSetStatus()
  const version = useAtomValue(presentationFolderResetAtom)
  return (
    <BorderedContainer>
      <FlowIdView
        key={`v.${version}`}
        flowId={jobFlowTag}
        CompletedFlowComponent={UserFiles}
        onFlowPoll={setStatus}
      />
    </BorderedContainer>
  )
}

function UserFiles({ result }: { result: GDriveFileResponse }) {
  return <CurrentUser files={result.data.data.files} />
}
